import '../assets/resetStyles.css'
import '@s-group/design-system-tokens/web/assets/fonts/SBonusUX.css'
import '@s-group/design-system-tokens/web/assets/fonts/SBonusDisplay.css'
import '@s-group/design-system-icons-styles/styles.css'
import '@s-group/design-system-components-styles/styles.css'
import '@s-group/design-system-tokens/web/tokens/s-pankki/colors.css'
import '@s-group/design-system-tokens/web/tokens/size.css'
import '@s-group/design-system-tokens/web/tokens/s-pankki/theme.css'

import { BrandWrapper } from '@s-group/design-system-components/BrandWrapper/BrandWrapper'
import * as theme from '@s-group/design-system-tokens/web/tokens/s-pankki/theme'
import { ReactNode } from 'react'
import { StyleSheetManager, ThemeProvider } from 'styled-components'

import { shouldForwardProp } from '../utilities/helpers'

export const BankBrandWrapper = ({ children }: { children?: ReactNode }) => (
  <StyleSheetManager shouldForwardProp={shouldForwardProp}>
    <BrandWrapper theme="sPankki">
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </BrandWrapper>
  </StyleSheetManager>
)
